









































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TinymceEditor from '@/components/tinymce-editor.vue'

@Component({ components: { TinymceEditor } })
export default class Article extends Vue {
    @Prop()
    private categoryId !: number;
    private myCategories = [];
    private curCategoryId = 0;

    private loading = false;

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;

    private editFormVisible = false;
    private editForm: any = {};

    created() {
        //this.$route.meta.goBack = this.categoryId;
        this.reloadCategory();
    }

    reloadCategory() {
        if (this.categoryId)
            this.curCategoryId = this.categoryId;

        this.reload();

        this.$apis.getMyCategories()
            .then((res: any) => {
                this.myCategories = res.data;
            });
    }

    onCategory(value: any) {
        this.curCategoryId = value;
        this.reload();
    }

    reload() {
        this.$apis.getArticles(this.curCategoryId, this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;
            });
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 详情
    onView(id: string) {
        this.$router.push({ path: "/study/content", query: { articleId: id } });
    }
}
